import React from 'react';
import { IonButton, IonSpinner, IonText } from '@ionic/react';
import HkModal from 'components/modal/HkModal';
import { getFallbackProductImage } from 'core/util/product-images';
import { formatInventoryFieldValue } from 'features/shared/inventory/utils/formatInventoryFieldValue';
import Image from 'assets/icons/image.svg';
import './InventoryDeleteConfirmModal.scss';

interface InventoryDeleteConfirmModalProps {
  isOpen: boolean;
  productName?: string;
  productModel?: string;
  productBrand?: string;
  productType?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * "Delete Confirm" modal (Figma frame CONFIRM-ITEM-DELETE-MODAL) — reached
 * from the item detail's Actions menu. Shown before any DELETE request is
 * issued.
 */
const InventoryDeleteConfirmModal: React.FC<
  InventoryDeleteConfirmModalProps
> = ({
  isOpen,
  productName,
  productModel,
  productBrand,
  productType,
  loading,
  onCancel,
  onConfirm
}) => {
  return (
    <HkModal
      className="hk-inventory-delete-confirm-modal"
      isOpen={isOpen}
      title="Delete Product Item"
      onClose={onCancel}
      footer={
        <div className="hk-inventory-delete-confirm-modal-actions">
          <IonButton
            className="hk-inventory-delete-confirm-modal-cancel-button"
            fill="outline"
            disabled={loading}
            onClick={onCancel}
          >
            Cancel
          </IonButton>
          <IonButton
            className="hk-inventory-delete-confirm-modal-delete-button"
            color="danger"
            disabled={loading}
            onClick={onConfirm}
          >
            {loading ? <IonSpinner name="dots" /> : 'Delete'}
          </IonButton>
        </div>
      }
    >
      <IonText className="hk-inventory-delete-confirm-modal-question">
        Are you sure you want to delete{' '}
        {productName ? `your ${productName}` : 'this item'}?
      </IonText>
      <div className="hk-inventory-delete-confirm-modal-item">
        <div className="hk-inventory-delete-confirm-modal-item-icon">
          <img
            src={productType ? getFallbackProductImage(productType) : Image}
            alt={productName || 'Product'}
          />
        </div>
        <div className="hk-inventory-delete-confirm-modal-item-text">
          <IonText className="hk-inventory-delete-confirm-modal-item-name">
            {productName}
          </IonText>
          <IonText className="hk-inventory-delete-confirm-modal-item-meta">
            Model: {formatInventoryFieldValue(productModel)}
          </IonText>
          <IonText className="hk-inventory-delete-confirm-modal-item-meta">
            Brand: {formatInventoryFieldValue(productBrand)}
          </IonText>
        </div>
      </div>
    </HkModal>
  );
};

export default InventoryDeleteConfirmModal;
